import { render, staticRenderFns } from "./Cosrute.vue?vue&type=template&id=7c351cd2&scoped=true"
import script from "./Cosrute.vue?vue&type=script&lang=js"
export * from "./Cosrute.vue?vue&type=script&lang=js"
import style0 from "./Cosrute.vue?vue&type=style&index=0&id=7c351cd2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c351cd2",
  null
  
)

export default component.exports